import Vue from 'vue';
import Router from 'vue-router';

import QES from './views/QES.vue';
import { children as QESChildRoutes } from './views/QES/routes';

import WALLET from './views/WALLET.vue';
import { children as WALLETChildRoutes } from './views/WALLET/routes';

// import store from '../src/stores/AppStore';
import i18n from './i18n';

Vue.use(Router);

let router = new Router({
  // changed to hash on 12/1/2022 to prevent 404 not found
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/wallet',
      component: WALLET,
      children: WALLETChildRoutes,
    },
    {
      path: '/QES',
      component: QES,
      children: QESChildRoutes,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // //   if (store.getters.step === 0) {
  // //     store.commit('decStep');
  // //     next({
  // //       path: '/',
  // //     });
  // //   } else if (to.path === '/') {
  // //     store.commit('step', 0);

  // //     next();
  // //   } else {
  // //     next();
  // //   }
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!to.meta.i18n) {
    Object.keys(to.meta.i18n).forEach((lang) =>
      i18n.mergeLocaleMessage(lang, to.meta.i18n[lang])
    );
  }
  next();
});
export default router;
